var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z","key":0}),React.createElement("polyline",{"points":"22,6 12,13 2,6","key":1})]);
}

Email.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-mail"};

module.exports = Email;

Email.default = Email;
